import * as React from "react";
import { Fragment } from "react";
import styled from "styled-components";
import { colors } from "../../styles";

const LabelDiv = styled.div`
  box-sizing: border-box;
  color: ${colors.grayDark};
  font-family: roboto-regular;
  font-size: 13px;
  letter-spacing: 0.86px;
  text-transform: uppercase;
  margin-top: 10px;
  margin-left: 2px;
`;

const ErrorText = styled.span`
  font-size: 12px;
  text-transform: unset;
`;

export interface LabelProps {
  label?: string;
  required?: boolean;
  valid?: boolean;
  error?: string;
}

export function TextFieldLabel({
  label,
  required = false,
  error,
  valid = !error,
}: LabelProps) {
  if (!label) {
    return null;
  }

  return (
    <LabelDiv
      className={`${
        !required || (required && valid) ? "" : "ltRed"
      } input-text`}
    >
      {required ? "* " : null}
      {label}
    </LabelDiv>
  );
}

export const HintText = styled.span`
  color: ${colors.gray};
  font-family: roboto-regular;
  font-size: 12px;
`;

export const TextFieldInput = styled.input`
  /* styles under the &&& class will override styles placed directly on the input element */
  &&& {
    margin-bottom: unset;
  }
  width: 100%;
`;

// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes
interface TextFieldProps extends LabelProps {
  className?: string;
  inputRef?: any; // ref callback, hard to type
  value?: string | number;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  hint?: React.ReactNode;
  type?: string;
  name?: string;
  placeholder?: string;
  onClick?: () => void;
  readOnly?: boolean;
  disabled?: boolean;
}

// This component uses the base text field class (including the base styles of the 'input' element) that was in use on Lightbulb
// BUT extended with the styles above
function TextField({
  label,
  required = false,
  className = "full-text-field",
  inputRef,
  value,
  valid,
  onChange,
  hint,
  error,
  ...props
}: TextFieldProps) {
  let labelComponent, hintComponent;
  if (label) {
    labelComponent = (
      <TextFieldLabel
        label={label}
        required={required}
        valid={valid}
        error={error}
      />
    );
  }
  if (hint) {
    hintComponent = <HintText>{hint}</HintText>;
  }

  return (
    <Fragment>
      {labelComponent}
      {hintComponent}
      <TextFieldInput
        ref={inputRef}
        className={className}
        value={value}
        onChange={onChange}
        {...props}
      />
    </Fragment>
  );
}

export default TextField;



// WEBPACK FOOTER //
// ./app/javascript/components/core/TextField.tsx